import { createDialog } from '@patsnap/tahiti-core';

export const figureAnnotationServiceFactory = createDialog(() => import('../components/FigureAnnotationDialog.vue'));
